export default "/sum.c889a4eb-499262.png";